import {useEffect, useState} from "react";
import {Search as SearchIcon, Users, MessageCircle, Store, UserRound, ChevronRight} from "lucide-react";
import {apiGet} from "@/lib/api";

const GROUPS = [
  ["circles", "Samaj", Users],
  ["questions", "Ask My Community", MessageCircle],
  ["brands", "Bazaar", Store],
  ["members", "Members", UserRound],
];

function ResultRow({kind, item, go, openMember}) {
  const map = {
    circles: [item.name, `${item.type} · ${item.topic || ""} · ${item.members || 1} members`, () => go("samaj", item.community_id)],
    questions: [item.text, `${item.author} · ${(item.tags || []).map(t => "#" + t).join(" ")}`, () => go("ask", item.question_id)],
    brands: [item.name, `${item.category} · ${item.location}`, () => go("bazaar", item.listing_id)],
    members: [item.name, [item.headline, item.city].filter(Boolean).join(" · "), () => openMember(item.user_id)],
  };
  const [title, sub, open] = map[kind];
  const id = item.community_id || item.question_id || item.listing_id || item.user_id;
  return (
    <button className="search-row" data-testid={`search-result-${kind}-${id}`} onClick={open}>
      <div><strong>{title}</strong><small>{sub}</small></div>
      <ChevronRight size={15}/>
    </button>
  );
}

export default function Search({initialQuery = "", setActive, openMember}) {
  const [q, setQ] = useState(initialQuery);
  const [res, setRes] = useState(null);

  useEffect(() => {
    if (q.trim().length < 2) { setRes(null); return; }
    const t = setTimeout(() => apiGet("/search", {q}).then(setRes).catch(() => setRes(null)), 250);
    return () => clearTimeout(t);
  }, [q]);

  const total = res ? GROUPS.reduce((n, [k]) => n + res[k].length, 0) : 0;

  return (
    <div data-testid="search-page">
      <div className="page-title">
        <div>
          <div className="eyebrow">SEARCH EVERYTHING</div>
          <h1>Shu <em>shodho cho?</em></h1>
          <p>Find samaj, questions, Bazaar products and members — all in one place.</p>
        </div>
      </div>
      <div className="search-box">
        <SearchIcon size={18}/>
        <input data-testid="search-input" autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Try garba, khakhra, Toronto, patola..."/>
      </div>
      {!res ? (
        <div className="search-suggest">
          <span>Popular:</span>
          {["garba", "navratri", "farsan", "wedding", "jewellery", "business"].map(s => (
            <button key={s} className="tag-chip" data-testid={`search-suggest-${s}`} onClick={() => setQ(s)}>#{s}</button>
          ))}
        </div>
      ) : total === 0 ? (
        <div className="empty-pane" data-testid="search-empty"><SearchIcon size={26}/><h3>Kai malyu nahi</h3><p>Nothing matched &ldquo;{q}&rdquo;. Try another word.</p></div>
      ) : (
        <div className="search-groups">
          {GROUPS.filter(([k]) => res[k].length).map(([k, label, Icon]) => (
            <section key={k} className="search-group" data-testid={`search-group-${k}`}>
              <div className="eyebrow"><Icon size={12}/> {label} ({res[k].length})</div>
              {res[k].map((item, i) => <ResultRow key={i} kind={k} item={item} go={setActive} openMember={openMember}/>)}
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
